import { formatDate } from 'date-fns/format';
import { Configuration, SuppliersApi } from '@/api';
import useFindSuppliersQuery from '@/api/queries/useFindSuppliersQuery';
import Button from '@/components/Button';
import Confirm from '@/components/Confirm';
import SpinnerIcon from '@/components/icons/SpinnerIcon';
import Pagination from '@/components/Pagination';
import { SearchProps } from '@/components/search/useSearch';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
// import { SettingsSupplierAddPath } from '@/modules/store/paths';
import { SettingsSupplierEditPath } from '@/modules/store/paths';
import { Link } from 'react-router-dom';

interface SupplierTableProps extends SearchProps {
  currentStoreId?: string;
}

const SupplierTable = ({
  searchQuery,
  page = 1,
  onChangePage = () => {},
  currentStoreId,
}: SupplierTableProps) => {
  const { suppliers, isLoading, error, itemsPerPage, invalidateQuery } = useFindSuppliersQuery(
    page,
    searchQuery,
  );

  const suppliersApi = new SuppliersApi(new Configuration(useAuth));

  const handleDeleteSupplier = async (id: string) => {
    try {
      await suppliersApi.deleteSupplier(id);

      await invalidateQuery();
    } catch (error) {
      console.error('Error while deleting supplier:', error);
    }
  };

  if (!isLoading && !error && suppliers.items.length === 0) {
    // const addSupplierButton = (
    //   <Button to={SettingsSupplierAddPath} variant="primary">
    //     Click here to add a new supplier
    //   </Button>
    // );

    return (
      <div className="flex flex-col items-center justify-center gap-8">
        <p>No suppliers found.</p>
      </div>
    );
  }

  return (
    <div className="table-container">
      <div className="table-wrapper">
        <table className={isLoading ? 'loading' : ''}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Created At</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {suppliers.items.map((supplier) => {
              if (supplier.id === undefined) {
                return;
              }
              return (
                <tr key={supplier.id}>
                  <td className="w-1/2">
                    <Link
                      to={SettingsSupplierEditPath.withId(supplier.id)}
                      className="text-blue-500 hover:underline"
                    >
                      {supplier.name}
                    </Link>
                  </td>
                  <td>{supplier.createdAt && formatDate(supplier.createdAt, 'd MMM yyyy')}</td>
                  <td>
                    {currentStoreId !== undefined &&
                      currentStoreId === supplier.createdByStoreId && (
                        <Confirm
                          onConfirm={() => handleDeleteSupplier(supplier.id)}
                          message={`Do you want to delete supplier: ${supplier.name}?`}
                        >
                          {(handleClick) => (
                            <Button onClick={handleClick} variant="delete" size="xs">
                              Delete
                            </Button>
                          )}
                        </Confirm>
                      )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {isLoading ? (
          <div role="status" className="loader">
            <SpinnerIcon />
            <span className="sr-only">Loading...</span>
          </div>
        ) : (
          ''
        )}
      </div>
      <div className="table-bottom">
        <Pagination
          currentPage={page}
          itemsPerPage={itemsPerPage}
          totalCount={suppliers.totalCount || 0}
          estimatedTotalCount={suppliers.estimatedTotalCount || 0}
          onClick={onChangePage}
        />
      </div>
    </div>
  );
};

export default SupplierTable;
